<!--
 * @Author: your name
 * @Date: 2020-03-04 17:50:16
 * @LastEditTime: 2020-07-24 10:26:32
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /gofun-conn-h5-protal/src/views/login/loginNew.vue
 -->

<template>
  <div class="loginPage commonPage">
    <div class="background">
      <div class="left_bg">
        <div class="left_content">
          <!-- <p class="left_tit1">欢迎使用GOFUN出行商家后台系统</p> -->
          <p class="left_tit2">GoFun全链接商家平台独特优势：自研TBOX硬件实现无人交车、自助取还，简化租车流程，提高人车比，节约成本。除传统的短租日租流量外，特有的分时、月租流量，可最大化车辆利用，增加收益。便捷的租车体验，帮您提升竞争力，助力业务增长。</p>
          <div class="btn_group">
            <div class="btn_item">
              <a href="https://www.shouqiev.com" target="_blakn">GOFUN官网</a>
              <i></i>
            </div>
            <div class="btn_item">
              <a href="https://www.wjx.cn/vm/hgjdZdg.aspx#" target="_blakn">GOFUN招商</a>
              <i></i>
            </div>
          </div>
        </div>
      </div>
      <div class="content">
        <img class="toplogo" src="../../assets/img/toplogo.png" alt="">
        <div class="form">
          <div class="formContainer">
            <el-form :model="userInfo" ref="userInfo" v-loading="loading" label-width="0" class="formBox">
              <el-form-item class="usernameBox" prop="username">
                <label class="label">账号</label>
                <el-input
                  maxlength="20"
                  clearable
                  v-model.trim="userInfo.username"
                  autocomplete="off"
                  placeholder="请输入账号"
                  @keyup.enter.native="login('userInfo')"
                ></el-input>
              </el-form-item>
              <el-form-item class="passwordBox" prop="password">
                <label class="label">密码</label>
                <el-input
                  maxlength="20"
                  type="password"
                  @keyup.enter.native="login('userInfo')"
                  clearable
                  v-model.trim="userInfo.password"
                  autocomplete="off"
                  placeholder="请输入密码"
                ></el-input>
              </el-form-item>
              <el-form-item class="passwordBox" prop="password">
                <label class="label">验证码</label>
                <el-input
                  maxlength="4"
                  type="text"
                  clearable
                  v-model.trim="picCode"
                  autocomplete="off"
                  placeholder="请输入验证码"
                >
                <img
                  v-if="imgCodeSec"
                  id="img-code"
                  style="height:40px;width:80px;cursor: pointer;"
                  :src='imgCodeSec'
                  slot="append"
                  @click="reloadImgCode()"
                  alt=""/>
                <span slot="append" v-else style="display:inline-block; height:40px;width:80px;background:white;"></span>
                <!-- <img
                  id="img-code"
                  style="height:40px;width:80px;"
                  :src='(this.$configServer.API_URL == "/api/" ? "//gc20.51gofunev.com/api/" : this.$configServer.API_URL) + "portal/interface/getCheckCode?"+randomCode'
                  slot="append"
                  alt=""> -->
                  <!-- <div slot="append">9999999999</div> -->
                  <!-- <identify ref="code" :contentWidth="80" slot="append"></identify> -->
                </el-input>
              </el-form-item>
              <el-form-item class="errorMsg" v-if="errorMessage" style="max-width: 306px;">
                <span>{{errorMessage}}</span>
                <!-- <span>登录账号已锁定，10分钟后自动解锁，或联系商户管理员解锁</span> -->
              </el-form-item>
              <el-form-item class="btnBox" style="text-align:center;">
                <el-button
                  :loading="isShowLoadingFlag"
                  class="loginBtn"
                  type="primary"
                  @click="login('userInfo')"
                  style="width:100%;"
                >登录</el-button>
              </el-form-item>
            </el-form>
            <div class="tip" @click="forget">忘记密码？</div>
          </div>
        </div>
        <div class="mb">
          <img src="../../assets/img/qrcode.png" alt="">
          <p>扫码下载商户端APP（安卓+ios）</p>
        </div>

        <!-- <img class="sologan" src="../../assets/img/sologan.png" alt=""> -->
        <div class="beian">
          <div style="padding: 10px 0;text-align: center;font-size: 14px;">
            <p>
              <a
                class="safe"
                target="_blank"
                href="http://www.beian.miit.gov.cn"
                style="color: #ffffff;text-decoration: none;"
              >京ICP备15050108号-1</a>
            </p>
            <p>
              <a
                class="safe"
                target="_blank"
                href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010502038224"
                style="color: #ffffff;text-decoration: none;"
              >
                <i
                  style="display: inline-block;width: 13px;height: 13px;background-image:url('https://www.shouqiev.com/images/country.png')"
                ></i>京公网安备: 11010502038224号
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import getJwtSafeCode from "../../utils/config-server/jwt"
import {encryptByDES} from '@/utils'
export default {
  data() {
    return {
      isShowLoadingFlag: false,
      userInfo: {
        username: "",
        password: ""
      },
      picCode: "",
      errorMessage: "",
      restTime: 0,
      restDesc: "",
      userinfoRules: {
        username: [
          { required: true, message: "请输入用户名", trigger: "blur" }
        ],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }]
      },
      loading: false,
      randomCode: '',
      imgCodeSec:""
    };
  },
  mounted() {
    this.getImgByXML()
    // if (process.env.API_ENV != 'production') {
    //   setTimeout(() => {
    //     this.picCode = this.$refs.code.identifyCode
    //   }, 1000)
    // }
  },
  methods: {
    ...mapActions({
      getMenuList: "getMenuList", // 将 `this.add()` 映射为 `this.$store.dispatch('increment')`
      getBtnList: "getBtnList"
    }),
    reloadImgCode() {
      // 重新加载验证码
      this.getImgByXML()
    },
    forget() {
      this.$router.push({
        path: "/findPass"
      });
    },
    login_enter() {
      if (this.userInfo.username && this.userInfo.password) {
        this.login("userInfo");
      }
    },
    login(formName) {
      if (!this.loginCheck()) return false
      this.loading = true
      this.$axios
        .get(this.$configServer.API_URL + "portal/login", {
          params: {
            loginName: encryptByDES(this.userInfo.username),
            password: encryptByDES(this.userInfo.password),
            yzmCode: this.picCode,
            mskey:this.randomCode
          }
        })
        .then(async res => {
          this.loading = false
          if (res.code !== 200) {
            this.errorMessage = ""
            // 安全改造-不是200情况都刷新验证码
            this.getImgByXML()
          } else {
            let {resultCode, token, headImg, qyUrl, name, loginName} = res.result;
            if (resultCode == "4") {
              // 密码过期修改密码
              sessionStorage.setItem("modifyInitPassLoginName", encryptByDES(loginName))
              this.$router.push({
                path:"/modifyInitPass",
                query: {
                  type: 2
                }
              })
            } else if (resultCode == "3") {
              // 账户锁定提示
              this.errorMessage = res.result.message
            } else if (resultCode == "2") {
              //失败三次需要验证码
              this.$common.message({
                message: "账号或密码错误",
                type: "error"
              });
            } else if (resultCode == "1") {
              //首次登陆需修改密码
              sessionStorage.setItem("modifyInitPassLoginName", encryptByDES(this.userInfo.username))
              this.$router.push({
                path:"/modifyInitPass",
                query: {
                  type: 1
                }
              })
            } else {
              localStorage.setItem("token", token);
              this.$common.setCookie("token", token);
              this.$common.setCookie("avatar", headImg);
              this.$common.setCookie("qyUrl", qyUrl);
              this.$common.setCookie("name", name);
              await this.getMenuList();
              await this.getBtnList();
              this.$router.replace({
                path: "/gofun"
              });
            }
          }
        }).catch(err => {
          console.log(err)
        })
    },
    loginCheck() {
      if (!this.userInfo.username) {
        this.$common.message({
          message: "请输入账号",
          type: "error"
        });
        return false;
      } else if (!this.userInfo.password) {
        this.$common.message({
          message: "请输入密码",
          type: "error"
        });
        return false;
      } else if (!this.picCode) {
        this.$common.message({
          message: "请输入验证码",
          type: "error"
        });
        return false;
      }
      //  else if (this.$refs.code.identifyCode != this.picCode.toLowerCase()) {
      //   this.$common.message({
      //     message: "验证码输入不正确",
      //     type: "error"
      //   });
      //   return false;
      // }
      return true;
    },
    getImgByXML(){
      if(!Blob){
        alert("请更换IE10+，或者使用Chrome浏览器")
      }
      let request = new XMLHttpRequest();
      request.responseType = "blob";
      this.randomCode = Math.random().toString(36).slice(-8);
      request.open("get", this.$configServer.API_URL + "portal/interface/getCheckCode?mskey=" + this.randomCode, true);
      request.setRequestHeader("Authorization", getJwtSafeCode());
      request.onreadystatechange = e => {
          if (request.readyState == XMLHttpRequest.DONE && request.status == 200) {
            console.log(request.response, 111111999)
            const blob = new Blob([request.response], { type: "application/png" });
            const url = window.URL.createObjectURL(blob);
            this.imgCodeSec = url
          }
      };
      request.send(null);
    }
  }
};
</script>

<style lang="scss">
.loginPage {
  width: 100%;
  height: 100%;
}
.loginPage .el-input-group__append {
  padding: 0;
}
.loginPage .el-input {
  width: 240px;
  margin-left: 20px;
}
.loginPage .el-input-group__append {
  border: none;
  background:none;
}
</style>

<style scoped lang="scss">
@import './left_bg.scss';
.loginPage {
  width: 100%;
  height: 100%;
  user-select: none;

  min-width: 1200px;
  min-height: 900px;
  display: flex;

  .background {
    width: 100%;
    height: 100%;
    // background-image: url('../../assets/img/bg_loading.png');
    // background-image: url('../../assets/img/login_bg.png');
    // background-size: 100% 1322px;
    // background-position: center center;
    // background-repeat: no-repeat;
    position: relative;
    display: flex;
    flex-wrap: nowrap;
    .content {
      // position: absolute;
      // right: 0;
      // top: 0;
      height: 100%;
      width: 36%;
      min-width: 420px;
      padding-top: 80px;
      background: #2b7bff;
      display: flex;
      align-items: center;
      justify-content: space-around;
      flex-direction: column;
      box-sizing: border-box;
      flex-shrink: 0;
      .toplogo {
        width: 222px;
        height: auto;
      }
      .mb{
        margin-top: 20px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        img{
          width: 149px;
          height: 149px;
        }
        p{
          margin-top: 14px;
          color: #fff;
        }
      }
      .form {
        background: #ffffff;
        border-radius: 4px;
        border-radius: 4px;
        padding: 40px 40px 38px 28px;
        // width: 360px;
        box-sizing: border-box;
        .label {
          width: 42px;
          text-align: justify;
          display: inline-block;
        }
        .title {
          font-family: PingFangSC-Regular;
          font-size: 20px;
          color: #000000;
          letter-spacing: 0;
          text-align: center;
        }
        .usernameBox {
          margin-bottom: 30px;
        }
        .passwordBox {
          margin-bottom: 40px;
        }
        .errorMsg {
          line-height: 30px;
          color: red;
          margin-bottom: 10px;
          margin-top: -20px;
          b {
            font-weight: 600;
          }
        }
      }
      .tip {
        margin-top: 0px;
        font-family: PingFangSC-Semibold;
        font-size: 12px;
        color: #3E7DF6;
        letter-spacing: 0.46px;
        line-height: 14px;
      }
      .sologan {
        width: 381px;
        height: auto;
      }
    }
  }
}
@media screen and (max-width:850px){
  .loginPage {
    min-width: 0;
    height: 0;
  }
  .loginPage .background .content{
    width: 100%;
    min-width: auto;
  }
  .loginPage .background .content .form{
    width: 100%;
    // margin-left: 10%;
  }
  .findPassPage .background .content .form {
    width: 80%;
    margin-left: 10%;
  }
}
</style>




// WEBPACK FOOTER //
// src/views/login/login.vue